import { TextField } from '@material-ui/core';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import React from 'react';
import {
	renderChargesTypeDefaultValue,
	renderDebitCreditDefaultValue,
	renderProperCase,
	renderRevenueDefaultValue,
} from './Common';

export const EntBill = ({ state, dispatch, outlet }) => {
	let majorAndTax = state?.entCharges?.filter(
		charge =>
			charge?.descriptionType === 'Major' ||
			charge?.descriptionType === 'OutletTaxPolicy',
	);
	let discAndPayment = state?.entCharges?.filter(
		charge =>
			charge?.descriptionType === 'DiscountType' ||
			charge?.descriptionType === 'DiscountTaxType' ||
			charge?.descriptionType === 'DiscountServiceChargeType' ||
			charge?.descriptionType === 'PaymentType',
	);
	return (
		<>
			<TableRow className="mapping-tr">
				<TableCell scope="row" style={{ boxShadow: '7px 0px 10px -8px rgba(138, 138, 138, 0.66)' }}>
					<span className="xsTitle ">Entertainment Bill</span>
				</TableCell>
				<TableCell align="left">
					<span className="xsTitle title-row">-</span>
				</TableCell>
				<TableCell align="left">
					<span className="xsTitle  title-row">-</span>{' '}
				</TableCell>
				<TableCell align="left">
					<span className="xsTitle title-row">-</span>{' '}
				</TableCell>
				<TableCell align="left">
					<span className="xsTitle title-row">-</span>
				</TableCell>
				<TableCell align="left">
					<span className="xsTitle title-row">-</span>
				</TableCell>
			</TableRow>
			{majorAndTax?.map((row, i) => (
				<TableRow className="mapping-tr" key={i}>
					<TableCell scope="row" style={{ boxShadow: '7px 0px 10px -8px rgba(138, 138, 138, 0.66)' }}>
						{'ENT '+renderProperCase(row?.description, row?.descriptionType)}
					</TableCell>
					<TableCell align="left">
						{state?.mode === 'edit' ? (
							row?.outletENTGLAccount?.revenueDiv ||
							renderRevenueDefaultValue(
								row?.descriptionType,
								'Division',
								outlet,
							)
						) : (
							<TextField
								id="outlined-basic"
								value={majorAndTax?.[i]?.outletENTGLAccount?.revenueDiv}
								placeholder={renderRevenueDefaultValue(
									row?.descriptionType,
									'Division',
									outlet,
								)}
								className="mapping-textfield"
								variant="outlined"
								onChange={event => {
									const cleaned = event?.target?.value.replace(/\s+/g, "");
                     console.log(cleaned, "cleaned"); // should have no spaces
									const newArr: any = state?.entCharges;
									let selected = newArr[i]?.outletENTGLAccount;
									selected.revenueDiv = cleaned;

									dispatch({
										type: 'entCharges',
										payload: newArr,
									});
								}}
							/>
						)}
					</TableCell>
					<TableCell align="left">
						{state?.mode === 'edit' ? (
							row?.outletENTGLAccount?.revenueDept ||
							renderRevenueDefaultValue(
								row?.descriptionType,
								'Department',
								outlet,
							)
						) : (
							<TextField
								id="outlined-basic"
								value={majorAndTax?.[i]?.outletENTGLAccount?.revenueDept}
								placeholder={
									row?.outletENTGLAccount?.revenueDept ||
									renderRevenueDefaultValue(
										row?.descriptionType,
										'Department',
										outlet,
									)
								}
								className="mapping-textfield"
								variant="outlined"
								onChange={event => {
									const cleaned = event?.target?.value.replace(/\s+/g, "");
                     console.log(cleaned, "cleaned"); // should have no spaces
									const newArr: any = state?.entCharges;
									let selected = newArr[i]?.outletENTGLAccount;
									selected.revenueDept = cleaned;

									dispatch({
										type: 'entCharges',
										payload: newArr,
									});
								}}
							/>
						)}
					</TableCell>
					<TableCell align="left">{row?.outletGLAccount?.type}</TableCell>
					<TableCell
						align="left"
						style={{
							backgroundColor: '#f5f5f5',
						}}
					></TableCell>
					<TableCell align="left">
						{state?.mode === 'edit' ? (
							row?.outletENTGLAccount?.revenueCredit ||
							`${renderProperCase(
								row?.description,
								row?.descriptionType,
							)} Revenue`
						) : (
							<TextField
								id="outlined-basic"
								value={majorAndTax?.[i]?.outletENTGLAccount?.revenueCredit}
								placeholder={`${renderProperCase(
									row?.description,
									row?.descriptionType,
								)} Revenue`}
								className="mapping-textfield"
								variant="outlined"
								onChange={event => {
									const cleaned = event?.target?.value.replace(/\s+/g, "");
                     console.log(cleaned, "cleaned"); // should have no spaces
									const newArr: any = state?.entCharges;
									let selected = newArr[i]?.outletENTGLAccount;
									selected.revenueCredit = cleaned;

									dispatch({
										type: 'entCharges',
										payload: newArr,
									});
								}}
							/>
						)}
					</TableCell>
				</TableRow>
			))}
			{discAndPayment?.map((row, i) => (
				<TableRow className="mapping-tr" key={i}>
					<TableCell scope="row" style={{ boxShadow: '7px 0px 10px -8px rgba(138, 138, 138, 0.66)' }}>
						{'ENT '+renderProperCase(row?.description, row?.descriptionType)}
					</TableCell>
					<TableCell align="left">
						{row?.descriptionType === 'PaymentType' ?
							state?.mode === 'edit' ? (
								row?.outletGLAccount?.revenueDiv ||
								renderRevenueDefaultValue(
									row?.descriptionType,
									'Division',
									outlet,
								)
							) : (
								<TextField
									id="outlined-basic"
									value={discAndPayment?.[i]?.outletGLAccount?.revenueDiv}
									placeholder={renderRevenueDefaultValue(
										row?.descriptionType,
										'Division',
										outlet,
									)}
									className="mapping-textfield"
									variant="outlined"
									onChange={event => {
										const cleaned = event?.target?.value.replace(/\s+/g, "");
                     console.log(cleaned, "cleaned"); // should have no spaces
										const newArr: any = state?.entCharges;
										let selected = newArr[i + majorAndTax?.length]?.outletGLAccount;
										selected.revenueDiv = cleaned;

										dispatch({
											type: 'entCharges',
											payload: newArr,
										});
									}}
								/>
							) : null}
						{row?.descriptionType === 'DiscountType' || row?.descriptionType === 'DiscountTaxType' || row?.descriptionType === 'DiscountServiceChargeType' ?
							state?.mode === 'edit' ? (
								row?.outletENTDiscountGLAcct?.revenueDiv ||
								renderRevenueDefaultValue(
									row?.descriptionType,
									'Division',
									outlet,
								)
							) : (
								<TextField
									id="outlined-basic"
									value={discAndPayment?.[i]?.outletENTDiscountGLAcct?.revenueDiv}
									placeholder={renderRevenueDefaultValue(
										row?.descriptionType,
										'Division',
										outlet,
									)}
									className="mapping-textfield"
									variant="outlined"
									onChange={event => {
										const cleaned = event?.target?.value.replace(/\s+/g, "");
                     console.log(cleaned, "cleaned"); // should have no spaces
										const newArr: any = state?.entCharges;
										let selected = newArr[i + majorAndTax?.length]?.outletENTDiscountGLAcct;
										selected.revenueDiv = cleaned;

										dispatch({
											type: 'entCharges',
											payload: newArr,
										});
									}}
								/>
							) : null}
					</TableCell>
					<TableCell align="left">
						{row?.descriptionType === 'PaymentType' ?
							state?.mode === 'edit' ? (
								row?.outletGLAccount?.revenueDept ||
								renderRevenueDefaultValue(
									row?.descriptionType,
									'Department',
									outlet,
								)
							) : (
								<TextField
									id="outlined-basic"
									value={discAndPayment?.[i]?.outletGLAccount?.revenueDept}
									placeholder={renderRevenueDefaultValue(
										row?.descriptionType,
										'Department',
										outlet,
									)}
									className="mapping-textfield"
									variant="outlined"
									onChange={event => {
										const cleaned = event?.target?.value.replace(/\s+/g, "");
                     console.log(cleaned, "cleaned"); // should have no spaces
										const newArr: any = state?.entCharges;
										let selected = newArr[i + majorAndTax?.length]?.outletGLAccount;
										selected.revenueDept = cleaned;

										dispatch({
											type: 'entCharges',
											payload: newArr,
										});
									}}
								/>
							) : null}
						{row?.descriptionType === 'DiscountType' || row?.descriptionType === 'DiscountTaxType' || row?.descriptionType === 'DiscountServiceChargeType' ?
							state?.mode === 'edit' ? (
								row?.outletENTDiscountGLAcct?.revenueDept ||
								renderRevenueDefaultValue(
									row?.descriptionType,
									'Department',
									outlet,
								)
							) : (
								<TextField
									id="outlined-basic"
									value={discAndPayment?.[i]?.outletENTDiscountGLAcct?.revenueDept}
									placeholder={renderRevenueDefaultValue(
										row?.descriptionType,
										'Department',
										outlet,
									)}
									className="mapping-textfield"
									variant="outlined"
									onChange={event => {
										const cleaned = event?.target?.value.replace(/\s+/g, "");
                     console.log(cleaned, "cleaned"); // should have no spaces
										const newArr: any = state?.entCharges;
										let selected = newArr[i + majorAndTax?.length]?.outletENTDiscountGLAcct;
										selected.revenueDept = cleaned;

										dispatch({
											type: 'entCharges',
											payload: newArr,
										});
									}}
								/>
							) : null}
					</TableCell>
					<TableCell align="left">
						{
							row?.descriptionType === 'DiscountType' || row?.descriptionType === 'DiscountTaxType' || row?.descriptionType === 'DiscountServiceChargeType'
								? row?.outletENTDiscountGLAcct?.type
								: row?.outletGLAccount?.type
						}
					</TableCell>
					<TableCell align="left">
						{row?.descriptionType === 'PaymentType' ?
							state?.mode === 'edit' ? (
								row?.outletGLAccount?.revenueDebit ||
								renderProperCase(
									renderDebitCreditDefaultValue(row?.description),
									row?.descriptionType,
								)
							) : state?.mode === 'save' ? (
								<TextField
									id="outlined-basic"
									value={discAndPayment?.[i]?.outletGLAccount?.revenueDebit}
									placeholder={renderProperCase(
										renderDebitCreditDefaultValue(row?.description),
										row?.descriptionType,
									)}
									className="mapping-textfield"
									variant="outlined"
									onChange={event => {
										const cleaned = event?.target?.value.replace(/\s+/g, "");
                     console.log(cleaned, "cleaned"); // should have no spaces
										const newArr: any = state?.entCharges;
										let selected = newArr[i + majorAndTax?.length]?.outletGLAccount;
										selected.revenueDebit = cleaned;

										dispatch({
											type: 'entCharges',
											payload: newArr,
										});
									}}
								/>
							) : null
							: null}
						{row?.descriptionType === 'DiscountType' || row?.descriptionType === 'DiscountTaxType' || row?.descriptionType === 'DiscountServiceChargeType' ?
							state?.mode === 'edit' ? (
								row?.outletENTDiscountGLAcct?.revenueDebit ||
								renderProperCase(
									renderDebitCreditDefaultValue(row?.description),
									row?.descriptionType,
								)
							) : state?.mode === 'save' ? (
								<TextField
									id="outlined-basic"
									value={discAndPayment?.[i]?.outletENTDiscountGLAcct?.revenueDebit}
									placeholder={renderProperCase(
										renderDebitCreditDefaultValue(row?.description),
										row?.descriptionType,
									)}
									className="mapping-textfield"
									variant="outlined"
									onChange={event => {
										const cleaned = event?.target?.value.replace(/\s+/g, "");
                     console.log(cleaned, "cleaned"); // should have no spaces
										const newArr: any = state?.entCharges;
										let selected = newArr[i + majorAndTax?.length]?.outletENTDiscountGLAcct;
										selected.revenueDebit = cleaned;

										dispatch({
											type: 'entCharges',
											payload: newArr,
										});
									}}
								/>
							) : null
							: null}
					</TableCell>
					<TableCell
						align="left"
						style={{
							backgroundColor: '#f5f5f5',
						}}
					></TableCell>
				</TableRow>
			))}
		</>
	);
};
